<template>
  <div class="priceControl">

      <div class="tableArea" >
        <div class="inln">
            <span class="tip"></span>
            <span>{{$t('other.a237')}}</span>
        </div>
        <div class="tti">
        <el-button size="mini" v-show="!isEditor" type="primary" @click="isEditor=true">{{$t('other.a238')}}</el-button>
        <el-button size="mini" v-show="isEditor" type="danger" @click="updataPrice()">{{$t('other.a239')}}</el-button>
        <el-button size="mini" v-show="isEditor" type="info" @click="isEditor=false">{{$t('other.a106')}}</el-button>
        <!-- <el-button size="mini" type="primary" @click="backTo()">{{$t('other.a1279')}}</el-button> -->
      </div>
        <el-table
            :data="groupInfo.storeItems"
            size="mini"
            border
            :header-cell-style="{background:'#e8e8e8',color:'#000'}"
            style="width: 100%;">
            <el-table-column prop="outTradeNo" fixed :label="$t('other.a217')" width="80">
                <template slot-scope="props">
                  <img   class="picBox"   :src="props.row.image" style="width: 50px; height: 50px"  />
                </template>
              </el-table-column>
            <el-table-column :label="$t('other.a218')">
                <template slot-scope="props">
                    <div>{{ props.row.skuName}}</div>
                </template>
            </el-table-column>
            <el-table-column :label="$t('other.a67')">
                <template slot-scope="props">
                    <div>{{ props.row.cusCode}}</div>
                </template>
            </el-table-column>
            <el-table-column :label="$t('other.a219')">
                <template slot-scope="props">
                    <div>￥{{ props.row.price}}</div>
                </template>
            </el-table-column>
            <el-table-column :label="$t('other.a220')" >
                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a240')}}
                       <el-tooltip class="item" effect="dark" :content="$t('other.a222')" placement="top-start">
                          <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                       </span>
                     <el-input v-show="isEditor" size="mini" style="width:120px" @blur="setPrice(1)" v-model="priceValue" :placeholder="$t('other.a307')"></el-input>
								</template>
                <template slot-scope="props">
                  <span>￥

                      <span v-show="!isEditor">{{props.row.lowestDistributePrice}}</span>
                    <el-input v-show="isEditor" style="width:80px;margin-left:10px" size="mini" v-model="props.row.lowestDistributePrice" ></el-input>
                  </span>
                </template>
              </el-table-column>
          
            
           
        </el-table>
    </div>

 
  </div>
</template>

<script>
import { getGruopAndTempInfo} from '../../utils/toolFun'
import distributionApi from '../../api/moudles/distribution'
import api from '../../api/api'
export default {
data(){
return{
    groupInfo:{
        image:null,
        totalStoreNum:0,
        storeItems:[],
    },
    type:2,
    agenList:[],
    orderList:[],
    userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    value:null,
    agentInfo:null,
    isEditor:false,
    priceValue:null,
}
},
created(){
    getGruopAndTempInfo({
        groupId:this.$route.query.groupId,
        productId:this.$route.query.productId,
    }).then(res => {
        console.log('res',res);
        this.groupInfo=res.groupInfo
        this.groupInfo.totalStoreNum=0
        
        this.groupInfo.storeItems.forEach(p => {
            this.groupInfo.totalStoreNum+=p.storeNum
            
        })

       
    })
    
},
methods:{
    chooseItem(num){
        this.type=num
    },

    unPublish(){
        console.log('value',this.orderList);
        let params={
            sellerGruop:this.orderList[0].groupId,
            sourceGroup:this.orderList[0].children[0].groupId,
            userId:this.userId
        }

        api
        .delistedProducts(params)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a236'))
        }else{
        this.$message.warning(res.msg)
        }
        })
        console.log('params',params);
    },
    getOrderList(){
        let list=this.agentInfo[this.value]
        this.orderList=list[0].storeItems
        this.orderList.forEach(p => {
            p.country=list[0].country
        })
        console.log('list',list);
    },

    setPrice(num){
      console.log(this.priceValue)
      if(num == 1) {
        if(this.priceValue !== '' && this.priceValue !== null){
          this.groupInfo.storeItems.forEach(p => {
            p.lowestDistributePrice=Number(this.priceValue).toFixed(2)
            
          })
        }
      }
    },

    //更新产品的供货价
    updataPrice(item){
        this.groupInfo.storeItems.forEach(p => {
            p.lowestDistributePrice=Number(p.lowestDistributePrice)
            console.log('p',p);
        
            
        })

        distributionApi
            .putAwayToDistribution(this.groupInfo)
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a232'))
            this.isEditor=false
            
            }else{
            this.$message.warning(res.msg)
            }
            })
    },

   

}
}

</script>
<style lang="scss" scoped>
@import "../../assets/scss/mixins";
.priceControl{

    background-color: #eee;

    .tti{
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin:10px 50px 10px 0;
    }

    .agentWrapper{
        margin: 10px;
        box-sizing: border-box;
        padding: 10px;
        background-color: #fff;
    }

    .tableArea{
        box-sizing: border-box;
        margin: 10px 0 0 0;
        padding: 10px;
        background-color: #fff;

        .orng{
            margin: 10px 0;
        }

        .inln{
            @include flex-start();
            font-weight: 700;
            font-size: 16px;
            color: rgba(0,0,0,.85);
            padding: 10px 0;
            margin-bottom: 20px;
        }

        .tip{
            display: inline-block;
            margin: 0 5px 0 0;
        }

        .tip::after{
            content: "";
            display: inline-block;
            width: 4px;
            height: 14px;
            background-color: #007bfc;
        }

        
    }

    .views{
        font-size: 20px;
        font-weight: 600;
        padding: 10px 0;
        color: rgba(0,0,0,.65);
    }

    .awrapper{
        display: flex;
        justify-content: space-between;

        .oknd{
            flex: 1;
            display: flex;
            justify-content: space-around;

            .yund{
                width: 30%;
                height: 150px;
                background-color: #fafafa;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding-left: 20px;

                .inlng{
                    font-size: 20px;
                    font-weight: 600;
                    padding-bottom: 5px;

                }

                .onirg{
                    font-size: 14px;
                }

                .yitn{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 18px;
                    
                    img{
                        width: 70%;
                    }
                }

                .yitn:nth-child(1){
                    background-color: #ccedff;
                   
                }

                .yitn:nth-child(2){
                    background-color: #fff3d7;
                   
                }
            }
            
        }

        .noog{
            display: flex;
            justify-content: flex-start;
        }

        .uolp{
            width: 350px;
            box-sizing: border-box;
            padding:0 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .bhyti{
                margin: 10px 0 0 0;
                color: rgba(0,0,0,.45);
            }

            .yimg{
                display: flex;
                align-content: center;
                padding: 3px 0;
                font-size: 15px;
                font-weight: 600;
            }

            .onkg{
                display: inline-block;
                width: 91px;
                text-align: right;
            }

            .onpk{
                display: inline-block;
                width: 115px;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .groupName{
                font-size: 16px;
                font-weight: bold;
                color: #757575;
                @include multiline-ellipsis(3)
            }
        }

        .imgBox{
            width: 150px;
            height: 150px;
            overflow: hidden;

            img{
                width: 100%;
            }
        }
    }
}
</style>